var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "key-schedule-edit" },
    [
      _c(
        "Sticky",
        {
          staticClass: "stick-save",
          attrs: {
            extendStickyClass: "stickyBtnClass",
            fullWidth: false,
            align: "right",
          },
        },
        [
          _c("div", { staticClass: "btnGroup" }, [
            !_vm.isEditing && _vm.allowGeneratePdf
              ? _c(
                  "button",
                  {
                    staticClass: "btn--darkblue generatePDF",
                    on: { click: _vm.generatePDF },
                  },
                  [_vm._v(_vm._s(_vm.$t("action.generatePDF")))]
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.isEditing && _vm.allowEdit
              ? _c(
                  "button",
                  {
                    staticClass: "btn--orange edit",
                    on: { click: _vm.triggerEditStatus },
                  },
                  [_vm._v(_vm._s(_vm.$t("action.edit")))]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.editMode
              ? _c(
                  "button",
                  {
                    staticClass: "btn--darkblue cancel",
                    on: { click: _vm.cancel },
                  },
                  [_vm._v(_vm._s(_vm.$t("action.cancel")))]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.editMode
              ? _c(
                  "button",
                  { staticClass: "btn--orange save", on: { click: _vm.save } },
                  [_vm._v(_vm._s(_vm.$t("action.save")))]
                )
              : _vm._e(),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "key-header" }, [
        _c("span", { staticClass: "remarks" }, [
          _c("div", { staticClass: "key-title" }, [
            _vm._v(_vm._s(_vm.$t("handover.remark"))),
          ]),
          _vm._v(" "),
          _c("i", { staticClass: "content" }, [
            _vm._v(
              _vm._s(
                _vm.$t(
                  "terms." + _vm.regionName + ".hotb.remark." + _vm.hotbType,
                  [_vm.premises]
                )
              )
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "content" }, [
        _c("table", [
          _c("thead", [
            _c("tr", [
              _c("th", { staticClass: "keyItem" }, [
                _vm._v(
                  "\n            " + _vm._s(_vm.$t("item")) + "\n          "
                ),
              ]),
              _vm._v(" "),
              _c("th", { staticClass: "key" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("handover.keySchedule.keys")) +
                    "\n          "
                ),
              ]),
              _vm._v(" "),
              _c("th", { staticClass: "keyHandedOver" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("handover.keySchedule.cards")) +
                    "\n          "
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "tbody",
            _vm._l(_vm.keyList, function (item, index) {
              return _c("tr", { key: index }, [
                _c("th", [
                  _c(
                    "div",
                    { staticClass: "handoverItem" },
                    [
                      _c("TextField", {
                        attrs: {
                          required: item.keys !== "" || item.cards !== "",
                          showColon: false,
                          readonly: !_vm.editMode,
                          value: _vm.editMode
                            ? item.keyItem
                            : item.keyItem || _vm.$t("emptyValue"),
                          inputTip: _vm.errorString,
                          placeholder: _vm.$t(
                            "handover.keySchedule.placeholderMsg"
                          ),
                        },
                        on: {
                          updateValue: function (val) {
                            return _vm.changeItemValue(index, val, "keyItem")
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("th", [
                  _c(
                    "div",
                    { staticClass: "handoverKeys" },
                    [
                      _c("InputField", {
                        attrs: {
                          readonly: !_vm.editMode,
                          showColon: false,
                          showFlag: false,
                          value: _vm.editMode
                            ? item.keys
                            : item.keys || _vm.$t("emptyValue"),
                          placeholder: _vm.$t(
                            "handover.keySchedule.placeholderEg6"
                          ),
                          inputTip: _vm.errorNumber,
                          inputCheckType: "integer",
                          pattern: _vm.regex.integer,
                          required: _vm.isKeysRequired(index),
                        },
                        on: {
                          updateValue: function (val) {
                            return _vm.changeItemValue(index, val, "keys")
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("th", { staticClass: "keyHandedOver" }, [
                  _c(
                    "div",
                    { staticClass: "handoverCards" },
                    [
                      _c("InputField", {
                        attrs: {
                          readonly: !_vm.editMode,
                          showColon: false,
                          showFlag: false,
                          value: _vm.editMode
                            ? item.cards
                            : item.cards || _vm.$t("emptyValue"),
                          placeholder: _vm.$t(
                            "handover.keySchedule.placeholderEg6"
                          ),
                          inputTip: _vm.errorNumber,
                          inputCheckType: "integer",
                          pattern: _vm.regex.integer,
                          required: _vm.isCardsRequired(index),
                        },
                        on: {
                          updateValue: function (val) {
                            return _vm.changeItemValue(index, val, "cards")
                          },
                        },
                      }),
                      _vm._v(" "),
                      _vm.editMode
                        ? _c("HKLDeleteIcon", {
                            staticClass: "delete",
                            on: {
                              click: function () {
                                return _vm.openDeleteConfirmModel(item, index)
                              },
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]),
              ])
            }),
            0
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("DeleteConfirmModel", { ref: "deleteKeyConfirmModel" }),
      _vm._v(" "),
      _vm.editMode
        ? _c("div", { staticClass: "footer" }, [
            _c(
              "i",
              { staticClass: "add", on: { click: _vm.addKeyListInner } },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("handover.keySchedule.addKeyItem")) +
                    "+\n    "
                ),
              ]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("KeyScheduleSignature", {
        ref: "keySignatureRef",
        attrs: { editStatus: _vm.editMode },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }